import { SpeciesParagraph } from '@/__generated__/graphql';
import { colors, GridWrapper, mediaQueries } from '@theme/lib';
import { ReactElement } from 'react';
import styled from 'styled-components';
import Arrow from './assets/arrow.svg';

const StyledSpeciesBlock = styled(GridWrapper)`
  .species-block__cards-list {
    list-style: none;
    display: flex;
    flex-flow: column nowrap;
    gap: 0.75rem;
    ${mediaQueries.md} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 0.75rem;
    }
    ${mediaQueries.lg} {
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 1rem;
    }
    ${mediaQueries.xl} {
      grid-gap: 2rem;
    }
  }
  .species-block__title {
    color: ${colors.white};
    font-size: 2rem;
    line-height: 110%;
    margin-bottom: 1.5rem;
    font-weight: 400;
    ${mediaQueries.xl} {
      font-size: 3rem;
      margin-bottom: 2.125rem;
    }
  }
  .species-block__card {
    position: relative;
    background-color: ${colors.seagrass};
    border-radius: 5px;
    min-height: 5rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    ${mediaQueries.xl} {
      min-height: 5.75rem;
    }
    a {
      display: block;
      text-decoration: none;
      padding: 0.75rem 1.5rem;
    }

    &:hover, &:focus {
      .species-block__card-title svg {
        transform: translateX(0.75rem);
      }
    }
  }

  .species-block__card-title {
    display: flex;
    justify-content: space-between;
    color: ${colors.white};
    margin-bottom: 0.375rem;
    font-weight: 400;
    line-height: 120%;

    > svg {
      transition: all 0.25s ease-in-out;
      margin-top: 0.375rem;
      margin-left: 1rem;
      flex-shrink: 0;

    }
  }
  .species-block__card-status {
    color: ${colors.honeyBee};
    font-weight: 400;
    font-size: 0.875rem;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: baseline;
    line-height: 110%;
    gap: 5px;
    &.cr-status {
      color: ${colors.white};
      background-color: ${colors.redPanda};
      font-size: 0.75rem;
      border-radius: 26px;
      padding: 5px 7px 4px 7px;
      animation: pulse 1.5s infinite;
      circle {
        fill: ${colors.white};
      }
    }
  }
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      animation-timing-function: ease-in;
    }
    50% {
      transform: scale(1.03);
    }
  }
`;

export default function SpeciesBlock(data: SpeciesParagraph): ReactElement<any> {
  if (!data?.speciesCards?.length) {
    return <></>;
  }
  return <StyledSpeciesBlock {...data} alignment={'full-width'}>
    <h2 className="species-block__title">{data.title}</h2>
    <ul className="species-block__cards-list">
      {data.speciesCards.map((card, key) => {
        return <li key={`species-block__card-${key}`} className="species-block__card">
          <a href={card.url || undefined}>
            <h5 className="species-block__card-title">{card.name} {card.url && <Arrow />}</h5>
            <div className={`species-block__card-status ${card?.iucnStatus && card.iucnStatus.toLowerCase().includes('critically endangered') ? 'cr-status' : ''}`}>
              <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="5" fill={`${colors.honeyBee}`}/>
              </svg>
              {card.iucnStatus}
            </div>
          </a>
        </li>
      })
    }
    </ul>
  </StyledSpeciesBlock>;
}
